const MESSAGES = {
  FIRST_START: "Начни игру!", // При первом открытии страницы

  START: "Разгадай шифровку", // Начало игры после «Начать игру» и «Играть ещё»

  // Сообщения при проверке слова
  WORD_WRONG: "Неверно. Попробуй ещё раз.",

  // Завершение раунда и игры
  ROUND_FINISHED: "Молодец! Нажми «Далее».",
  GAME_FINISHED: "Все слова отгаданы. Чтобы начать с начала, нажми «Играть ещё».",
} as const;

export default MESSAGES;